<template>
  <v-container fluid class="pa-0 ma-0">
    <v-app id="inspire">
      <v-card class="elevation-0">
        <v-img class="white--text" max-height="590px" src="@/assets/aboutusbg.jpg">
          <v-container>
            <div class="mt-16 mx-lg-8 pt-lg-16">
              <v-row no-gutters>
                <v-col cols="12" sm="4" md="5">
                  <v-card class="ma-2 mt-16">
                    <div class="waviy">
                      <h1 class="clrbluetext font-weight-bold fd50SS">Sactin ERP</h1>
                      <h2 class="linespht spans clrbluetext font-weight-bold">
                        Discover. Discuss. Develop.
                      </h2>
                    </div>
                  </v-card>
                </v-col>

                <v-col cols="12" sm="8" md="7">
                  <v-card
                    class="pa-2 ma-2 d-flex align-center justify-center htlargef mt-sm-16 mt-xl-8"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/dgxg.png"
                      class="fill-height zoom-effect"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-container>
        </v-img>
      </v-card>

      <!-- start sec part -->
      <!-- start sec part -->
      <v-card class="elevation-0">
        <v-container>
          <div class="mx-lg-8">
            <v-row no-gutters>
              <!-- LEFT COLUMN -->
              <v-col cols="12" sm="4" lg="3">
                <!-- observer wrapper for mobile heading -->
                <!-- <div ref="leftHeadingMobile" class="observer">
                  <h1
                    class="rainbow-text text-center d-block d-lg-none font-weight-bold linespht display-1 anim-item fade-up delay-100"
                    style="font-size: clamp(24px, 5vw, 56px)"
                  >
                    Our Company Story
                  </h1>
                </div> -->

                <!-- observer wrapper for image card -->
                <div ref="imageCard2" class="observer">
                  <v-card
                    class="px-2 mx-2 pb-2 mb-2 d-none d-sm-block align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>

              <!-- RIGHT COLUMN -->
              <v-col cols="12" sm="8" lg="9">
                <v-card class="ma-2">
                  <!-- <div ref="rightHeadingDesktop" class="observer">
                    <h1
                      class="rainbow-text d-none d-lg-block font-weight-bold linespht anim-item fade-up delay-150"
                      style="font-size: clamp(20px, 4vw, 32px) !important"
                    >
                      Our Company Story
                    </h1>
                  </div> -->

                  <div ref="paragraph" class="observer">
                    <p
                      class="mt-6 mt-lg-14 text-justify linespht1 black--text body-1 anim-item fade-left delay-300"
                    >
                      SACTIN software is established and proven solution offered from
                      BUYUK and widely accepted product in many schools in all over India
                      now. With the proven track success of the campuses today we are
                      proud to have SACTIN in our family products which is the next
                      generation software for campus management. SACTIN is the product
                      that can cater to all kind of educational institutions. It is a
                      complete we be enabled solution for education alI institutions,
                      providing sophisticated software applications simply through a web
                      browser. The users of SACTIN can access information from anywhere,
                      at any time of day.
                      <br />
                      SACTIN has been built from the ground, in close coordination with
                      various schools, the design architects have built the SACTIN
                      solution that supports the widely differing administrative processes
                      as well as different educational model that can be easily
                      customizable.
                    </p>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <!-- observer wrapper for image card -->
              <v-col>
                <div ref="imageCard1" class="observer">
                  <v-card
                    class="px-12 mx-2 pb-2 mb-2 d-block d-sm-none align-center justify-center htlargef2 anim-item zoom-in delay-200"
                    height="100%"
                  >
                    <v-img
                      src="@/assets/companystory.jpg"
                      class="fill-height"
                      contain
                      max-width="100%"
                    />
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
      <!-- end sec part -->

      <!-- start 2nd section -->

      <v-container fluid class="pa-4">
        <v-card class="black--text elevation-0" dark>
          <v-container>
            <v-row class="mrtopmobile" justify="center">
              <!-- Start card loop -->
              <v-col
                v-for="(card, index) in cards"
                :key="index"
                cols="12"
                sm="6"
                lg="4"
                xl="4"
                class="d-flex justify-center"
              >
                <div class="a-box">
                  <div class="img-container"></div>
                  <div
                    class="text-container d-flex flex-column justify-space-between bgpanel"
                  >
                    <v-card class="ma-3 elevation-3 animate-card">
                      <v-img
                        :src="getImagetracking(card.image)"
                        height="200px"
                        class="brradius ma-3"
                        style="width: 60px; height: 60px"
                      ></v-img>

                      <v-card-title class="pa-3">{{ card.title }}</v-card-title>

                      <p class="pa-3 body-1 text-justify">
                        {{ card.description }}
                      </p>
                    </v-card>
                  </div>
                </div>
              </v-col>
              <!-- End card loop -->
            </v-row>
          </v-container>
        </v-card>
      </v-container>

      <!-- end 2nd section -->

      <!-- start footer -->
      <WebsiteFooter />
      <!-- end footer -->
    </v-app>
  </v-container>
</template>

<script>
import WebsiteFooter from "../WebsitePages/WebsiteFooter.vue";
export default {
  components: {
    WebsiteFooter,
  },
  data() {
    return {
      observer: null,
      cards: [
        {
          title: "Online Admission ",
          description:
            "This module will help one to have an online application for the admission of their siblings or relatives through the SACTIN App itself. ",
          image: "Featuresicon1.png",
        },
        {
          title: "Assessment ",
          description:
            "An excellent module to conduct the exams. The teacher can preset the question paper as a pdf or can even take the picture of the question paper. ",
          image: "Featuresicon2.png",
        },
        {
          title: "Time Table ",
          description:
            "The time table will be prepared by the teachers for the entire Academic Year and can be viewed by the students as daily view or weekly view. ",
          image: "Featuresicon3.png",
        },

        {
          title: "Notice ",
          description:
            "A module where the  principal can issue a notice to whole school. It can be restricted to teachers only, parents only or to a particular  class or even division. ",
          image: "Featuresicon4.png",
        },
        {
          title: "Exam Marks ",
          description:
            "The marks gained by the students for each exams like Pre Mid-term, Mid-term and Post Mid-term and the test papers will be displayed in this module. ",
          image: "Featuresicon5.png",
        },

        {
          title: "Voice Message ",
          description:
            "An advanced messaging system by Sactin where the Principal can send a voice note to Parents or Teachers which they will receive as a voice call. ",
          image: "Featuresicon6.png",
        },
        {
          title: "Birthdays ",
          description:
            "Principal will be given the notification of Birthdays of every student day by day, and have an option to send a wish for the child directly. The wish can be customized or will have a default one by Sactin. ",
          image: "Featuresicon2.png",
        },
        {
          title: "Account ",
          description:
            "Accounting software records and processes accounting transactions using modules that include Complete Financial Transactions with in an Institution Like accounts payable, accounts receivable. ",
          image: "Featuresicon3.png",
        },

        {
          title: "SMS ",
          description:
            "Bulk messaging is an important system in the school which cannot be replaced. We provide a system limited number of messages can be sent to parents at free of cost. ",
          image: "Featuresicon5.png",
        },
        {
          title: "Test Papers ",
          description:
            "The notification about an exam can be dropped in this module. Which all topics has to be covered, How many mark exam will be conducted etc. ",
          image: "Featuresicon3.png",
        },
        {
          title: "Bus Tracking ",
          description:
            "The GPS device connected to the bus gives the Principal and Parents a close watch on where the bus is and how much time will it take to reach each of the stop. ",
          image: "Featuresicon2.png",
        },
        {
          title: "Homeworks ",
          description:
            "The teachers can give Home works to the students right from the SACTIN App. Just have to give a title and add the required question or attach a file which is preset. ",
          image: "Featuresicon3.png",
        },
        {
          title: "Visitors ",
          description:
            "This module with the help of Security log in gives a track record of all the visitors coming to the school where all the details including the photo of the visitors can be collected and it will be shared to the Principal in Real Time no matter wherever he/she is. ",
          image: "Featuresicon2.png",
        },
        {
          title: "My ID ",
          description:
            "Sactin provides the ID cards to full Students and Teachers with great design and quality. For the teachers and  higher class students there is an option for RFID cards where their attendance can be tracked with a Biometric Device we provide. ",
          image: "Featuresicon4.png",
        },
        {
          title: "Attendance ",
          description:
            "The attendance of the students can be marked through Sactin App. The teacher will have some options like Present, Late, Late with Excuse, Half day or Absent. They can even add some remarks for each student so that the notification will be sent to the parent. ",
          image: "Featuresicon6.png",
        },
        {
          title: "Search Students ",
          description:
            "The Principal can search out for the students in the school at a go with one click. The students can be seen class wise and division wise. Complete details on each student with the parent details and contact numbers can be viewed. ",
          image: "Featuresicon4.png",
        },
        {
          title: "E-diary ",
          description:
            "A module which helps to replace the conventional diary and can have all the records of each and every notes given by the teachers to students. The parents will be receiving a notification as a teacher gives a note on this module. ",
          image: "Featuresicon6.png",
        },
        {
          title: " Feedbacks",
          description:
            "This is a module where the parent can request/give a feedback of their child to a particular subject teacher in person. The teacher can reply back for the concern. This conversation is restricted to a single teacher. ",
          image: "Featuresicon6.png",
        },
        {
          title: "Chat ",
          description:
            "A Unique module which practically dissolves the use of class social media groups like WhatsApp. A teacher can chat with a particular class in common. The teacher can view all the chats from all students but each student gets the reply for their own chat only. ",
          image: "Featuresicon6.png",
        },

        {
          title: "Online Class Links ",
          description:
            "Online classes are taken on different platforms by different schools/teachers like Google Meet, MS Teams, Zoom, WebEx etc. Those class Links can be shared through the App so that the Principal can have track on how many classes has been taken by the teacher and on which platform. ",
          image: "Featuresicon2.png",
        },
        {
          title: "Quiz ",
          description:
            "A fun based module by Sactin to do a quick activity during the classes. Teacher can create a question and post it with options and once it is received the students can appear the quiz. If they are clicking the right answer they will be given a specific mark etc. ",
          image: "Featuresicon5.png",
        },

        {
          title: "Profile ",
          description:
            "A module where all the personal data of a student or a teacher can be viewed, including their contact number Address Educational qualifications of the teachers etc. ",
          image: "Featuresicon3.png",
        },

        {
          title: "Library ",
          description:
            "A module Exclusively for the Library Teacher. The complete list of books in the Library will be integrated. A student can Chat with the Librarian, Track Books, Request books, View return dates, Track on the books taken by each students, Can find out the knowledge master with most no. of books taken etc. ",
          image: "Featuresicon5.png",
        },
        {
          title: "Students ",
          description:
            " The students will be given the details of every teachers of their particular classes. They can call them directly with the contact numbers provided in the Sactin App.",
          image: "Featuresicon4.png",
        },

        {
          title: "Teachers ",
          description:
            "This module for teachers will provide them to view the students of the particular classes assigned for them. ",
          image: "Featuresicon4.png",
        },
        {
          title: "Gallery ",
          description:
            "This module will contain the Photos and videos of the events which takes place in the school. ",
          image: "Featuresicon5.png",
        },
      ],
    };
  },
  methods: {
    getImagetracking(imageName) {
      return require(`@/assets/bus trcking/${imageName}`);
    },
    getImage(imageName) {
      return require(`@/assets/${imageName}`);
    },
  },
  mounted() {
    const observer1 = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer1.unobserve(entry.target); // run only once
          }
        });
      },
      { threshold: 0.2 } // trigger when 20% visible
    );

    document.querySelectorAll(".process-circle").forEach((el) => {
      observer1.observe(el);
    });
    const options = {
      root: null,
      rootMargin: "0px 0px -10% 0px",
      threshold: 0.1,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const anim = entry.target.querySelector(".anim-item");
        if (!anim) return;

        if (entry.isIntersecting) {
          anim.classList.add("in-view"); // play animation
        } else {
          anim.classList.remove("in-view"); // reset when out of view
        }
      });
    }, options);

    [
      "leftHeadingMobile",
      "imageCard1",
      "imageCard2",
      "rightHeadingDesktop",
      "paragraph",
    ].forEach((ref) => {
      const el = this.$refs[ref];
      if (el) observer.observe(el);
    });
  },
  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
  },
};
</script>

<style scoped>
::v-deep .theme--light.v-icon {
  color: white;
}
::v-deep .theme--light.v-sheet {
  background-color: transparent !important;
  border-color: transparent !important;
  color: white;
}
::v-deep .theme--dark.v-sheet {
  background-color: transparent;
  border-color: transparent;
  color: black;
}
::v-deep .v-sheet.v-card:not(.v-sheet--outlined) {
  box-shadow: none !important;
}
.linespht {
  line-height: 1.5;
  letter-spacing: 2px;
}
.linespht1 {
  line-height: 1.5;
  letter-spacing: 1px;
}
@media screen and (min-width: 1100px) and (max-width: 1300px) {
  .htlargef {
    height: 90% !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1301px) and (max-width: 1670px) {
  .htlargef {
    height: 90% !important;
  }
  .fd50SS {
    font-size: 50px !important;
  }
  .htlargeproductscn {
    height: 650px !important;
  }
  .htlargecertificatescn {
    height: 510px !important;
  }
}
@media screen and (min-width: 1671px) {
  .htlargef {
    height: 70% !important;
  }
  .fd50SS {
    font-size: 60px !important;
  }
  .htlargeproductscn {
    height: 710px !important;
  }
  .htlargecertificatescn {
    height: 710px !important;
  }
}
.htlargef2 {
  height: 100% !important;
}
.clrblues {
  background-color: #04357e !important;
  color: white;
}
@media screen and (min-width: 700px) {
  .fd20 {
    font-size: 20px;
  }
  .fd50 {
    font-size: 40px;
    line-height: 1.5;
    letter-spacing: 2px;
  }
  .fd50SS {
    font-size: 50px;
  }
  .htlargeproductscn {
    height: 1115px;
  }
  .fd20ss {
    font-size: 30px !important;
  }
}

/* start card */
.a-box {
  display: inline-block;
  width: 100% !important;

  text-align: center;
}

.img-container {
  height: 120px;
  width: 200px;
  overflow: hidden;
  border-radius: 0px 0px 20px 20px;
  display: inline-block;
}

.text-container {
  /* box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2); */
  padding: 10px;
  border-radius: 20px;
  /* background: #e5e5e5; */
  background: white;
  margin: -120px 0px 0px 0px;
  line-height: 19px;
  font-size: 14px;
  /* height: 200px; */
  /* height: 260px; */
}

.text-container h3 {
  margin: 20px 0px 10px 0px;
  /* color: #04bcff; */
  font-size: 18px;
}
.brradius {
  border-radius: 12px !important;
}

/* start slider */
.v-slide-group__prev,
.v-slide-group__next {
  color: purple; /* Customize the arrow color */
}
/* end slider */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}
.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }
  20% {
    transform: translateY(-20px);
  }
}

/* end a1 */

/* a2 */

.contentan {
  position: relative;
}

.contentan h2 {
  color: #fff;
  font-size: 3em;
  position: absolute;
  transform: translate(-50%, -50%);
}

.contentan h2:nth-child(1) {
  color: transparent;
  -webkit-text-stroke: 2px #04357e;
  /* -webkit-text-stroke: 2px  #2A65BF; */
}

.contentan h2:nth-child(2) {
  color: #04357e;
  animation: animate 4s ease-in-out infinite;
}

@keyframes animate {
  0%,
  100% {
    clip-path: polygon(
      0% 45%,
      16% 44%,
      33% 50%,
      54% 60%,
      70% 61%,
      84% 59%,
      100% 52%,
      100% 100%,
      0% 100%
    );
  }

  50% {
    clip-path: polygon(
      0% 60%,
      15% 65%,
      34% 66%,
      51% 62%,
      67% 50%,
      84% 45%,
      100% 46%,
      100% 100%,
      0% 100%
    );
  }
}
.letpx {
  left: 80px;
}
/* end a2 */
.clrbluetext {
  /* color: #04357e !important; */
  color: black;
}
/* ::v-deep .bgpanel.v-card.v-sheet.theme--light {
  background-color: #f8f8ff !important;
}
::v-deep .bgpanel {
  background-color: #f8f8ff !important;
} */

/* start a1 */
.waviy {
  position: relative;
  -webkit-box-reflect: below -20px linear-gradient(transparent, rgba(0, 0, 0, 0.2));
  /* font-size: 40px; */
}

.waviy .spans {
  /* font-family: 'Alfa Slab One', cursive; */
  position: relative;
  display: inline-block;
  color: #fff;
  /* text-transform: uppercase; */
  animation: waviy 1s infinite;
  animation-delay: calc(0.1s * var(--i));
}

@keyframes waviy {
  0%,
  40%,
  100% {
    transform: translateY(0);
  }

  20% {
    transform: translateY(-20px);
  }
}
.rainbow-text {
  background: linear-gradient(
    90deg,
    red,
    orange,
    yellow,
    green,
    blue,
    indigo,
    violet,
    red
  );
  background-size: 400% 400%;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: rainbow-move 8s linear infinite;
}

@keyframes rainbow-move {
  0% {
    background-position: 0% 50%;
  }

  50% {
    background-position: 100% 50%;
  }

  100% {
    background-position: 0% 50%;
  }
}
/* end a1 */
.process-circle-wrap {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  border: 3px solid #e29803;
  /* Vuetify primary color */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}

.process-circle-icon {
  font-size: 30px;
  margin-bottom: 10px;
}

.process-circle-num {
  position: absolute;
  bottom: -15px;
  background: #e29803;
  color: #fff;
  border-radius: 50%;
  padding: 5px 12px;
  font-weight: bold;
}
/* Shared hidden state */
.anim-item {
  opacity: 0;
  transition-property: opacity, transform;
  transition-duration: 800ms;
  transition-timing-function: cubic-bezier(0.2, 0.8, 0.2, 1);
}

/* When in-view */
.anim-item.in-view {
  opacity: 1;
  transform: translate(0, 0) scale(1);
}

/* Types */
.fade-up {
  transform: translateY(40px);
}
.fade-up.in-view {
  transform: translateY(0);
}

.fade-left {
  transform: translateX(40px);
}
.fade-left.in-view {
  transform: translateX(0);
}

.zoom-in {
  transform: scale(0.9);
}
.zoom-in.in-view {
  transform: scale(1);
}

/* Optional delay helpers */
.delay-100 {
  transition-delay: 0.1s;
}
.delay-150 {
  transition-delay: 0.15s;
}
.delay-200 {
  transition-delay: 0.2s;
}
.delay-300 {
  transition-delay: 0.3s;
}
@keyframes zoomInOut {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* zoom in */
  }
  100% {
    transform: scale(1); /* back to normal */
  }
}

.zoom-effect {
  animation: zoomInOut 6s ease-in-out infinite; /* continuous zoom */
  transition: transform 0.3s ease-in-out;
}

.process-circle {
  position: relative;
  background: white;
  border-radius: 50%;
  padding: 30px;
  text-align: center;
  transition: all 0.4s ease; /* smooth animation */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg); /* zoom + tilt */
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3); /* stronger glow */
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 10px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg); /* spin icon */
}

.process-circle-text h3 {
  margin: 0;
  font-size: 18px;
  transition: color 0.3s ease;
}

.process-circle:hover .process-circle-text h3 {
  color: #e29803; /* change text color on hover */
}
.process-circle {
  opacity: 0;
  transform: translateY(50px);
  transition: all 0.8s ease;
}

.process-circle.visible {
  opacity: 1;
  transform: translateY(0);
}

.process-circle:nth-child(1) {
  transition-delay: 0.2s;
}
.process-circle:nth-child(2) {
  transition-delay: 0.4s;
}
.process-circle:nth-child(3) {
  transition-delay: 0.6s;
}
.process-circle:nth-child(4) {
  transition-delay: 0.8s;
}
.process-circle {
  width: 150px; /* fixed width */
  height: 150px; /* equal height */
  border-radius: 50%; /* make it a circle */
  background: white;
  display: flex;
  flex-direction: column; /* stack icon + text + number */
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto; /* center inside column */
  position: relative;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: all 0.4s ease;
  cursor: pointer;
}

.process-circle:hover {
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle:hover .process-circle-icon {
  transform: rotate(360deg);
}

.process-circle-num {
  position: absolute;
  bottom: -20px; /* place number outside circle */
  font-weight: bold;
  font-size: 18px;
  color: white;
}
@keyframes pulseLoop {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
  50% {
    transform: scale(1.08);
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  }
}

.process-circle {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0 auto;
  position: relative;
  cursor: pointer;

  /* 👇 add looping animation */
  animation: pulseLoop 3s ease-in-out infinite;
}

.process-circle-icon {
  font-size: 32px;
  margin-bottom: 8px;
  transition: transform 0.4s ease;
}

.process-circle-num {
  position: absolute;
  bottom: -20px;
  font-weight: bold;
  font-size: 18px;
  color: white;
}
.fontfamMon {
  font-family: Montserrat !important;
}
::v-deep .bgpanel {
  background-image: linear-gradient(120deg, #fdfbfb 0%, #ebedee 100%);
}
/* Floating loop animation */
@keyframes floatLoop {
  0% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
  100% {
    transform: translateY(0px);
  }
}

.animate-card {
  animation: floatLoop 3s ease-in-out infinite;
}
</style>
